/* lib/chat/frameRouter.js — маршрутизатор SSE-кадров чата (порт из frontend/src/lib/chat/frameRouter.js, 1:1).
 * Неизвестный/отсутствующий type → no-op (forward-compatible). */
export const FRAME_HANDLERS = {
  user: (e, h) => h.onUser?.(e),
  delta: (e, h) => h.onDelta?.(e.content || ''),
  ttk_partial: (e, h) => h.onTtkPartial?.(e.fragment || ''),
  menu_partial: (e, h) => h.onMenuPartial?.(e.fragment || ''),
  foodcost_partial: (e, h) => h.onReportPartial?.('foodcost', e.fragment || ''),
  abc_partial: (e, h) => h.onReportPartial?.('abc', e.fragment || ''),
  inventory_partial: (e, h) => h.onReportPartial?.('inventory', e.fragment || ''),
  tool_call_start: (e, h) => h.onToolCallStart?.(e.call_id, e.name, e.label || ''),
  tool_call_end: (e, h) => h.onToolCallEnd?.(e.call_id, !!e.ok, e.summary || ''),
  sources: (e, h) => h.onSources?.(Array.isArray(e.items) ? e.items : []),
  editor_action: (e, h) => h.onEditorAction?.(e.editor, e.prefill || {}),
  navigate: (e, h) => h.onNavigate?.(e.kind, e.id, e.title || ''),
  confirm_action: (e, h) => h.onConfirmAction?.(e),
  draft_entity: (e, h) => h.onDraftEntity?.(e),
  done: (e, h) => h.onDone?.(e),
  error: (e, h) => h.onError?.(e),
  specialist_start: (e, h) => h.onSpecialistStart?.(e),
  specialist_end: (e, h) => h.onSpecialistEnd?.(e),
  route_thinking: (e, h) => h.onRouteThinking?.(e),
};

export function routeFrame(evt, handlers) {
  const fn = FRAME_HANDLERS[evt && evt.type];
  if (fn) fn(evt, handlers || {});
}
